import { assertNever } from '@eversports/utility-types'
import React from 'react'

import useBookingDetails from '../../data/useBookingDetails'

import DesktopBookableItemBookingDetails from './desktop/DesktopBookableItemBookingDetails'
import { DesktopBookingRequestDetails } from './desktop/DesktopBookingRequestDetails'
import DesktopInvoiceDetails from './desktop/DesktopInvoiceDetails'
import DesktopProductBookingDetails from './desktop/DesktopProductBookingDetails'
import DesktopSkeletonBookingDetails from './Skeletons/DesktopSkeletonBookingDetails'

const DesktopBookingDetails: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { bookingDetails, isBookingDetailsLoading } = useBookingDetails()

  if (isBookingDetailsLoading || !bookingDetails) {
    return <DesktopSkeletonBookingDetails />
  }

  switch (bookingDetails.type) {
    case 'invoice':
      return <DesktopInvoiceDetails venue={bookingDetails.venue} invoice={bookingDetails.invoice} />
    case 'product':
      return <DesktopProductBookingDetails venue={bookingDetails.venue} product={bookingDetails.product} />
    case 'bookableItem':
      return (
        <DesktopBookableItemBookingDetails
          bookableItem={bookingDetails.bookableItem}
          settleWith={bookingDetails.settleWith}
          hasSpotBooking={bookingDetails.hasSpotBooking}
          assignedSpot={bookingDetails.assignedSpot}
        />
      )
    case 'bookingRequest':
      return (
        <DesktopBookingRequestDetails
          bookableItem={bookingDetails.bookableItem}
          trainer={bookingDetails.trainer}
          start={bookingDetails.start}
          end={bookingDetails.end}
          settleWith={bookingDetails.settleWith}
        />
      )
    case 'unsupported':
      throw new Error('Not able to support this booking item')
    default:
      return assertNever(bookingDetails)
  }
}

export default DesktopBookingDetails
